module.exports = __webpack_public_path__ + "img/hyu_gallery13.5201a4cc.jpg";